/**
 * Template - Data mapper for RFI1 - Trim
 * Section UID (in template) : Section Path in data
 */
export const rfi1TrimSectionMapper = {
  //Business Capabilities
  total_capabilities: 'dynamic_sections.business_capability.total_capabilities',
  certifications: 'dynamic_sections.business_capability.certifications',

  //Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',

  //Other Information
  office_information: 'dynamic_sections.other_information.office_information',
}
